define("shared/components/shared/image", ["exports", "@ember/component", "@ember/template-factory", "@ember/debug", "@ember/string", "@glimmer/component", "shared/types/image", "shared/utils/platform-check"], function (_exports, _component, _templateFactory, _debug, _string, _component2, _image, _platformCheck) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/string",0,"@glimmer/component",0,"shared/types/image",0,"shared/utils/platform-check"eaimeta@70e063a35619d71f

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <picture data-test-id="shared-image">
    {{#each this.sources as |imageSource|}}
      <source
        height={{imageSource.height}}
        media={{imageSource.media}}
        sizes={{imageSource.sizes}}
        srcset={{imageSource.src}}
        type={{imageSource.type}}
        width={{imageSource.width}}
      />
    {{/each}}
    <img
      alt={{@picture.alt}}
      class={{@class}}
      src={{this.fallbackSource.src}}
      type={{this.fallbackSource.type}}
      ...attributes
    />
  </picture>
  */
  {
    "id": "5zrhSI5r",
    "block": "[[[10,\"picture\"],[14,\"data-test-id\",\"shared-image\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,0,[\"sources\"]]],null]],null],null,[[[1,\"    \"],[10,\"source\"],[15,\"height\",[30,1,[\"height\"]]],[15,\"media\",[30,1,[\"media\"]]],[15,\"sizes\",[30,1,[\"sizes\"]]],[15,\"srcset\",[30,1,[\"src\"]]],[15,\"width\",[30,1,[\"width\"]]],[15,4,[30,1,[\"type\"]]],[12],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[11,\"img\"],[16,\"alt\",[30,2,[\"alt\"]]],[16,0,[30,3]],[16,\"src\",[30,0,[\"fallbackSource\",\"src\"]]],[16,4,[30,0,[\"fallbackSource\",\"type\"]]],[17,4],[12],[13],[1,\"\\n\"],[13]],[\"imageSource\",\"@picture\",\"@class\",\"&attrs\"],false,[\"each\",\"-track-array\"]]",
    "moduleName": "shared/components/shared/image.hbs",
    "isStrictMode": false
  });

  // Note: Ranked based on best support on all devices and browsers
  const RANKED_MIME_TYPE = [_image.MimeType.Png, _image.MimeType.Jpg, _image.MimeType.Svg, _image.MimeType.Gif, _image.MimeType.Webp, _image.MimeType.Avif];

  var _parseSources = /*#__PURE__*/new WeakSet();

  var _getFallbackSource = /*#__PURE__*/new WeakSet();

  class ImageComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _getFallbackSource);

      _classPrivateMethodInitSpec(this, _parseSources);

      (false && !(typeof this.args.picture === 'object') && (0, _debug.assert)('Must provide `picture` object', typeof this.args.picture === 'object'));
    }

    get isIos() {
      return (0, _platformCheck.isIos)(navigator);
    }

    get sources() {
      const sources = _classPrivateMethodGet(this, _parseSources, _parseSources2).call(this, this.args.picture.sources); // Note: iOS bug, skip AVIF for iOS.
      // iOS 16.1 is supposed to support animated AVIF so it attempts to load AVIF source but fails
      // no widely supported way to detect if it's animated or not so skipping AVIF for iOS completely
      // https://bugs.webkit.org/show_bug.cgi?id=248755
      // https://bugs.webkit.org/show_bug.cgi?id=247831


      if (this.isIos) {
        return sources.filter(source => source.type !== _image.MimeType.Avif);
      }

      return sources;
    }

    get fallbackSource() {
      return _classPrivateMethodGet(this, _getFallbackSource, _getFallbackSource2).call(this, this.sources);
    }

  }

  _exports.default = ImageComponent;

  function _parseSources2(sources) {
    const parsedSources = [];

    for (const source of sources) {
      if (typeof source === 'object') {
        parsedSources.push(source);
      } else if (typeof source === 'string') {
        const fileExtension = source.split('.').pop();

        if (!fileExtension) {
          throw new Error('Unable to determine file extension.');
        }

        const type = _image.MimeType[(0, _string.capitalize)(fileExtension)];

        parsedSources.push({
          src: source,
          type
        });
      }
    }

    return parsedSources;
  }

  function _getFallbackSource2(sources) {
    for (const type of RANKED_MIME_TYPE) {
      for (const source of sources) {
        if (source.type === type) {
          return source;
        }
      }
    }

    throw new Error('Unable to find fallback media.');
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ImageComponent);
});